import UsaLayout from "./layout/USALayout";
import ServiceHeader from "./USA-Components/ServiceHeader";
import CoreSolutions from "./USA-Components/CoreSolutions";
import BusinessesChoose from "./USA-Components/BusinessesChoose";
import Transform from "./USA-Components/Transform";

const USAServices = () => {
    return (
        <UsaLayout>
            <>
                <ServiceHeader/>
                <CoreSolutions/>
                <BusinessesChoose/>
                <Transform/>
            </>
        </UsaLayout>
    )
}

export default USAServices;